import { render } from "./HeroiconsOutlinePhoneIncoming.vue?vue&type=template&id=9849debc"
const script = {}

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlinePhoneIncoming.vue"]])

export default __exports__